// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cq-a";
export var fulfillmentFormRail = "_cq-9";
export var headerTitleRow = "_cq-c";
export var orderDetailsWrapper = "_cq-7";
export var orderLinkTrigger = "_cq-2";
export var paymentInformationGrid = "_cq-h";
export var paymentSummaryColumn = "_cq-i";
export var shipmentContainer = "_cq-b";
export var shipmentDetailsMainPane = "_cq-8";
export var shipmentNavigationCard = "_cq-5";
export var shipmentNavigationRail = "_cq-3";
export var shipmentNavigationRailHeader = "_cq-4";
export var shipmentSummaryFact = "_cq-e";
export var shipmentSummaryGrid = "_cq-d";
export var shipmentSummaryMetadataRow = "_cq-f";
export var shipmentSummaryTags = "_cq-g";
export var shipmentWorkspace = "_cq-0";
export var shipmentWorkspaceContent = "_cq-6";
export var shipmentWorkspaceHeader = "_cq-1";